'use client'

import { Builder } from '@builder.io/react'

import { BigFooter } from './BigFooter'
import { defaultColumns, defaultDisclaimers } from './BigFooter.defaults'
import { BigFooterColumn } from './BigFooterColumn'

Builder.registerComponent(BigFooter, {
  name: 'BigFooter',
  inputs: [
    {
      name: 'columns',
      type: 'list',
      subFields: [
        {
          name: 'column',
          type: 'uiBlocks',
          defaultValue: defaultColumns,
        },
      ],
      defaultValue: [
        {
          column: defaultColumns,
        },
      ],
    },
    {
      name: 'disclaimers',
      type: 'list',
      subFields: [
        {
          name: 'disclaimer',
          type: 'uiBlocks',
          defaultValue: defaultDisclaimers,
        },
      ],
      defaultValue: [
        {
          disclaimer: defaultDisclaimers,
        },
      ],
    },
    {
      name: 'appStoreUrl',
      type: 'string',
      localized: true,
    },
    {
      name: 'googlePlayUrl',
      type: 'string',
      localized: true,
    },
    {
      name: 'instagramUrl',
      type: 'string',
      localized: true,
    },
    {
      name: 'facebookUrl',
      type: 'string',
      localized: true,
    },
    {
      name: 'youtubeUrl',
      type: 'string',
      localized: true,
    },
    {
      name: 'faqText',
      type: 'string',
      localized: true,
      defaultValue: 'Contact us/FAQ',
    },
    {
      name: 'faqUrl',
      type: 'string',
      localized: true,
    },
    {
      name: 'certificateBadges',
      type: 'list',
      subFields: [
        {
          name: 'imageUrl',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
        },
        {
          name: 'alt',
          type: 'text',
        },
      ],
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/box-align-bottom.svg',
})

Builder.registerComponent(BigFooterColumn, {
  name: 'BigFooterColumn',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'EN US TITLE',
      localized: true,
    },
    {
      name: 'items',
      type: 'list',
      subFields: [
        {
          name: 'text',
          type: 'string',
          localized: true,
        },
        {
          name: 'href',
          type: 'string',
          localized: true,
        },
        {
          name: 'action',
          friendlyName: 'Click Action',
          type: 'string',
          defaultValue: 'none',
          enum: ['none', 'showOsanoDrawer'],
        },
        {
          name: 'showOnlyInUS',
          type: 'boolean',
          friendlyName: 'Display only in US region and English locale',
          defaultValue: false,
        },
      ],
      defaultValue: [],
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/box-align-bottom-left.svg',
})
